/** @format */

import { useEffect } from "react";
import { useRouter } from "next/router";

const BirdEyeWidget: React.FC = () => {
  const router = useRouter();
  const { location } = router.query;

  useEffect(() => {
    const widgetId = "bf-revz-widget-9876543219915183";
    const scriptSrc =
      "https://birdeye.com/embed/v7/171598355822954/9/9876543219915183";

    if (scriptSrc && !document.querySelector(`script[src="${scriptSrc}"]`)) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = scriptSrc;
      script.async = true;

      const container = document.getElementById("bf-revz-widget-container");
      if (container) {
        container.innerHTML = "";
        container.appendChild(script);
        container.innerHTML += `<div id="${widgetId}"></div>`;
      }
    }
  }, [location]);

  return <div id='bf-revz-widget-container'></div>;
};

export default BirdEyeWidget;
